import React, { Component } from "react";
import TopHeader from "../template/TopHeader";
import { connect } from "react-redux";
import ClientSidebar from "./ClientSidebar";
import axios from 'axios';
import API from "../../config/API";
import Lottie from "react-lottie";
import animationData from "../../assets/animation-data/loader.json";
import "./Clients.css";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

class Ownership extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      breakdown: null,
      isSalonOwner: false,
    };
  }

  componentDidMount() {
    this.loadOwnershipBreakdown();
  }

  loadOwnershipBreakdown = async () => {
    try {
      this.setState({ loading: true });

      // Check if user is salon owner
      const user = this.props.authentication?.user || JSON.parse(localStorage.getItem('user'));
      const isSalonOwner = user?.hairdresser?.isSalonOwner === 1;

      this.setState({ isSalonOwner });

      const response = await axios.get(API.HAIRDRESSER_CLIENTS_OWNERSHIP, {
        headers: {
          'Content-Type': 'application/json',
          'accessToken': localStorage.getItem('accessToken'),
        }
      });

      if (response.data && response.data.responseData && response.data.responseData.data) {
        this.setState({
          breakdown: response.data.responseData.data,
          loading: false,
        });
      } else {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error("Error loading ownership breakdown:", error);
      this.setState({ loading: false });
    }
  };

  renderPieChart = () => {
    const { breakdown } = this.state;
    if (!breakdown) return null;

    const total = breakdown.own + breakdown.shared + breakdown.salon;
    if (total === 0) return null;

    // Calculate percentages and angles
    const ownPercent = (breakdown.own / total) * 100;
    const sharedPercent = (breakdown.shared / total) * 100;
    const salonPercent = (breakdown.salon / total) * 100;

    // For SVG pie chart using conic-gradient
    const ownAngle = (breakdown.own / total) * 360;
    const sharedAngle = (breakdown.shared / total) * 360;
    const salonAngle = (breakdown.salon / total) * 360;

    return (
      <div className="ownership-chart-container">
        <div className="pie-chart-wrapper">
          <div
            className="pie-chart"
            style={{
              background: `conic-gradient(
                #4CAF50 0deg ${ownAngle}deg,
                #2196F3 ${ownAngle}deg ${ownAngle + sharedAngle}deg,
                #FF9800 ${ownAngle + sharedAngle}deg 360deg
              )`,
            }}
          >
            <div className="pie-chart-center">
              <div className="total-count">{total}</div>
              <div className="total-label">Total Clients</div>
            </div>
          </div>
        </div>

        <div className="chart-legend">
          <div className="legend-item">
            <div className="legend-color" style={{ backgroundColor: '#4CAF50' }}></div>
            <div className="legend-details">
              <div className="legend-label">My Clients</div>
              <div className="legend-value">
                {breakdown.own} ({ownPercent.toFixed(1)}%)
              </div>
            </div>
          </div>

          <div className="legend-item">
            <div className="legend-color" style={{ backgroundColor: '#2196F3' }}></div>
            <div className="legend-details">
              <div className="legend-label">Shared with Salon</div>
              <div className="legend-value">
                {breakdown.shared} ({sharedPercent.toFixed(1)}%)
              </div>
            </div>
          </div>

          <div className="legend-item">
            <div className="legend-color" style={{ backgroundColor: '#FF9800' }}></div>
            <div className="legend-details">
              <div className="legend-label">Salon Clients</div>
              <div className="legend-value">
                {breakdown.salon} ({salonPercent.toFixed(1)}%)
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderStaffBreakdown = () => {
    const { breakdown } = this.state;
    if (!breakdown || !breakdown.byHairdresser || breakdown.byHairdresser.length === 0) {
      return null;
    }

    return (
      <div className="staff-breakdown-section mt-5">
        <h4>Breakdown by Team Member</h4>
        <div className="staff-breakdown-table mt-3">
          <table className="clients-table">
            <thead>
              <tr>
                <th>Team Member</th>
                <th className="text-center">Employment Type</th>
                <th className="text-center">Client Count</th>
                <th className="text-center">Sharing Status</th>
              </tr>
            </thead>
            <tbody>
              {breakdown.byHairdresser.map((hairdresser, index) => (
                <tr key={index}>
                  <td>
                    <div className="staff-name-cell">
                      <div className="client-avatar">
                        {hairdresser.name?.[0] || 'H'}
                      </div>
                      <strong>{hairdresser.name}</strong>
                    </div>
                  </td>
                  <td className="text-center">
                    <span className={`employment-badge ${hairdresser.employmentType}`}>
                      {hairdresser.employmentType === 'employed' ? 'Employed' : 'Self-Employed'}
                    </span>
                  </td>
                  <td className="text-center">
                    <strong>{hairdresser.clientCount}</strong>
                  </td>
                  <td className="text-center">
                    <span className={`sharing-badge ${hairdresser.isSharing ? 'sharing' : 'not-sharing'}`}>
                      {hairdresser.isSharing ? 'Sharing' : 'Not Sharing'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  render() {
    const { loading, breakdown, isSalonOwner } = this.state;

    return (
      <div className="h_n">
        <div className="body_container cm_bg_white">
          <TopHeader title="Clients" headerButtonStatus={true} {...this.props} />
          <div className="new-setting-wrapper">
            <div className="container">
              <div className="row">
                <div className="col-md-4 col-sm-12 mobile-hidden">
                  <ClientSidebar />
                </div>
                <div className="col-md-8">
                  <div className="clients-table-container clients-page-padded">
                    <div className="ownership-header">
                      <h2>Client Ownership</h2>
                      <p className="text-muted">
                        Overview of client ownership and sharing
                      </p>
                    </div>

                    {loading ? (
                      <div className="text-center mt-5">
                        <Lottie options={defaultOptions} height={100} width={100} />
                      </div>
                    ) : !breakdown ? (
                      <div className="alert alert-warning mt-4">
                        <p>Unable to load ownership data. Please try again later.</p>
                      </div>
                    ) : (
                      <>
                        {this.renderPieChart()}

                        <div className="ownership-stats mt-5">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="stat-card own-clients">
                                <div className="stat-icon">
                                  <i className="fa fa-user"></i>
                                </div>
                                <div className="stat-details">
                                  <div className="stat-value">{breakdown.own}</div>
                                  <div className="stat-label">My Clients</div>
                                  <div className="stat-description">
                                    Clients I own exclusively
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="stat-card shared-clients">
                                <div className="stat-icon">
                                  <i className="fa fa-share-alt"></i>
                                </div>
                                <div className="stat-details">
                                  <div className="stat-value">{breakdown.shared}</div>
                                  <div className="stat-label">Shared Clients</div>
                                  <div className="stat-description">
                                    My clients shared with salon
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="stat-card salon-clients">
                                <div className="stat-icon">
                                  <i className="fa fa-building"></i>
                                </div>
                                <div className="stat-details">
                                  <div className="stat-value">{breakdown.salon}</div>
                                  <div className="stat-label">Salon Clients</div>
                                  <div className="stat-description">
                                    Clients from other team members
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {isSalonOwner && this.renderStaffBreakdown()}

                        <div className="ownership-info mt-4 p-3 bg-light rounded">
                          <h5>Understanding Client Ownership</h5>
                          <ul className="mb-0">
                            <li>
                              <strong>My Clients:</strong> Clients you added or who booked with you first
                            </li>
                            <li>
                              <strong>Shared Clients:</strong> Your clients that you've chosen to share with the salon
                            </li>
                            <li>
                              <strong>Salon Clients:</strong> Clients from other team members that are shared with the salon
                            </li>
                            {isSalonOwner && (
                              <li>
                                <strong>As a salon owner:</strong> You can see all shared clients from your team
                              </li>
                            )}
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

export default connect(mapStateToProps)(Ownership);